import { Button } from '@mui/material';
import { IconEye } from '@tabler/icons-react';
import React from 'react';

export default function BtnView({ style, disabled, onClick, ...props }) {
  const customStyle = { cursor: 'pointer', ...style };

  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      style={customStyle}
      {...props}>
      <IconEye height={20} />
    </Button>
  );
}
